export default __webpack_public_path__ + "static/media/Banner2.34a43bda.png";